import { State } from './types'

export const initialState: State = {
  maxBudget: 0,
  propertyTypes: ['house', 'apartment'],
  operationType: '',
  sharesCommission: true,
  location: { 
    fullAddress: '',
    streetNumber: '',
    street: '',
    neighborhood: '',
    town: '',
    location: '',
    postalCode: '',
    searchLevel: '',
    placeId: '',
    coordinates: {
      lat: 0,
      lng: 0
    }
   }
}
